module.exports = __webpack_public_path__ + "static/images/jxcj-2.cfc7e3fcb.png";